export default __webpack_public_path__ + "static/media/Ordeño panoramico.87ad8df8.jpeg";